import { getVolume3DProjectionSnapshot, volume3DProjectionAdapter, } from './volume3DProjectionAdapter';
export { DefaultVolume3DDataProvider } from './DefaultVolume3DDataProvider';
export { createDefaultVolume3DRenderPaths, createVolume3DRenderPathResolver, } from './Volume3DRenderPathResolver';
export const volume3DProjection = {
    adapter: volume3DProjectionAdapter,
    getSnapshot: getVolume3DProjectionSnapshot,
};
export { default } from './viewport3D';
